/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Step_Up_PromptInputs */

const id_staff_step_up_prompt = /** @type {(inputs: Staff_Step_Up_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan kode autentikator untuk mengonfirmasi tindakan ini.`)
};

const en_staff_step_up_prompt = /** @type {(inputs: Staff_Step_Up_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your authenticator code to confirm this action.`)
};

/**
* | output |
* | --- |
* | "Enter your authenticator code to confirm this action." |
*
* @param {Staff_Step_Up_PromptInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_step_up_prompt = /** @type {((inputs?: Staff_Step_Up_PromptInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Step_Up_PromptInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_step_up_prompt(inputs)
	return id_staff_step_up_prompt(inputs)
});